var map = {
	"./environment.dev3": "WNZ7",
	"./environment.dev3.ts": "WNZ7",
	"./environment.mirror": "Cxm6",
	"./environment.mirror.ts": "Cxm6",
	"./environment.perf": "ODtf",
	"./environment.perf.ts": "ODtf",
	"./environment.prod": "cxbk",
	"./environment.prod.ts": "cxbk",
	"./environment.staging": "JlwR",
	"./environment.staging.ts": "JlwR",
	"./environment.test": "en/V",
	"./environment.test.ts": "en/V",
	"./environment.test2": "Phq+",
	"./environment.test2.ts": "Phq+",
	"./environment.ts": "AytR",
	"./environment.www": "gU2t",
	"./environment.www.ts": "gU2t"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "tUhB";